import React, { useState } from 'react';
import Table from '../../../../app/components/Table';
import Pagination from '../../../../app/components/Pagination';
import { FiEdit } from 'react-icons/fi';
import FormEditTaxObligation from '../../../../forms/Obligations/FormEditObligation';
import Button from '../../../../app/components/Button';
import Toast from '../../../../app/components/Toast';
import { FiPlus } from 'react-icons/fi';

const Obligations = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedObligation, setSelectedObligation] = useState(null);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  const showToast = (type, message) => {
    setToast({ show: true, type, message });
  };

  const [obligations, setObligations] = useState([
    {
      id: 1,
      nome: 'Declaração de Imposto de Renda',
      departamento: 'Fiscal',
      responsavel: 'João Silva',
      passivelMulta: 'Sim',
      status: 'ativo',
    },
    {
      id: 2,
      nome: 'DCTF',
      departamento: 'Contábil',
      responsavel: 'Maria Oliveira',
      passivelMulta: 'Sim',
      status: 'ativo',
    },
    {
      id: 3,
      nome: 'EFD-Contribuições',
      departamento: 'Fiscal',
      responsavel: 'Carlos Santos',
      passivelMulta: 'Sim',
      status: 'inativo',
    },
    {
      id: 4,
      nome: 'GIA',
      departamento: 'Fiscal',
      responsavel: 'Ana Pereira',
      passivelMulta: 'Não',
      status: 'ativo',
    },
    {
      id: 5,
      nome: 'EFD-ICMS/IPI',
      departamento: 'Fiscal',
      responsavel: 'Roberto Lima',
      passivelMulta: 'Sim',
      status: 'inativo',
    },
    {
      id: 6,
      nome: 'SINTEGRA',
      departamento: 'Fiscal',
      responsavel: 'Fernanda Costa',
      passivelMulta: 'Não',
      status: 'ativo',
    },
    {
      id: 7,
      nome: 'DeSTDA',
      departamento: 'Fiscal',
      responsavel: 'Pedro Alves',
      passivelMulta: 'Sim',
      status: 'ativo',
    },
    {
      id: 8,
      nome: 'SPED Contábil',
      departamento: 'Contábil',
      responsavel: 'Luciana Martins',
      passivelMulta: 'Sim',
      status: 'inativo',
    },
    {
      id: 9,
      nome: 'DIRF',
      departamento: 'Fiscal',
      responsavel: 'Marcos Oliveira',
      passivelMulta: 'Sim',
      status: 'ativo',
    },
    {
      id: 10,
      nome: 'DEFIS',
      departamento: 'Contábil',
      responsavel: 'Juliana Soares',
      passivelMulta: 'Sim',
      status: 'ativo',
    },
  ]);

  const [filtro] = useState('');
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 10;

  const colunas = [
    { titulo: 'ID', campo: 'id' },
    { titulo: 'NOME', campo: 'nome' },
    { titulo: 'DEPARTAMENTO', campo: 'departamento' },
    { titulo: 'RESPONSÁVEL', campo: 'responsavel' },
    { titulo: 'PASSÍVEL DE MULTA?', campo: 'passivelMulta' },
    { titulo: 'AÇÕES', tipo: 'acoes', centralizado: true },
  ];

  const handleEdit = (obligation) => {
    setSelectedObligation(obligation);
    setIsFormOpen(true);
  };

  const handleNewObligation = () => {
    setSelectedObligation(null);
    setIsFormOpen(true);
  };

  const handleFormClose = () => {
    setIsFormOpen(false);
    setSelectedObligation(null);
  };

  const handleFormSubmit = (formData) => {
    if (formData.id) {
      setObligations(obligations.map(obl => 
        obl.id === formData.id ? { ...obl, ...formData } : obl
      ));
      showToast('success', 'Obrigação editada com sucesso!');
    } else {
      const newId = Math.max(...obligations.map(obl => obl.id), 0) + 1;
      setObligations([...obligations, { ...formData, id: newId, status: 'ativo' }]);
      showToast('success', 'Nova obrigação cadastrada com sucesso!');
    }

    setIsFormOpen(false);
  };


  const getActionsForObligation = (obligation) => {
    return [
      {
        icon: FiEdit,
        label: 'Editar',
        onClick: () => handleEdit(obligation)
      },
    ];
  };

  const obligationsWithActions = obligations.map(obligation => ({
    ...obligation,
    acoes: getActionsForObligation(obligation)
  }));

  const obligationsFiltrados = filtro 
    ? obligationsWithActions.filter(obligation => 
        obligation.nome.toLowerCase().includes(filtro.toLowerCase()) ||
        obligation.departamento.toLowerCase().includes(filtro.toLowerCase()) ||
        obligation.responsavel.toLowerCase().includes(filtro.toLowerCase())
      )
    : obligationsWithActions;

  const totalPages = Math.ceil(obligationsFiltrados.length / itensPorPagina);
  const indiceInicial = (paginaAtual - 1) * itensPorPagina;
  const indiceFinal = indiceInicial + itensPorPagina;
  const obligationsPaginados = obligationsFiltrados.slice(indiceInicial, indiceFinal);

  const handlePageChange = (page) => {
    setPaginaAtual(page);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <Button onClick={handleNewObligation}>
          <FiPlus size={17} />
          Cadastrar
        </Button>
        {/*<div className="flex items-center">
          <div className="mr-4">
            <h2 className="text-lg font-medium text-gray-900 flex items-center">
              Obrigações Fiscais 
              <span className="ml-2 bg-gray-200 text-gray-700 text-xs font-medium rounded-full h-5 w-5 flex items-center justify-center">
                {obligations.length}
              </span>
            </h2>
          </div>
        </div>*/}
      </div>

      <div className="overflow-x-auto -mx-3 sm:mx-0">
        <Table 
          colunas={colunas}
          dados={obligationsPaginados}
        />
      </div>

      {obligationsFiltrados.length > 0 && (
        <Pagination 
          currentPage={paginaAtual} 
          totalPages={totalPages} 
          onPageChange={handlePageChange}
          showPageNumbers={true}
          maxPageNumbers={5}
        />
      )}

      <FormEditTaxObligation 
        isOpen={isFormOpen}
        onClose={handleFormClose}
        title={selectedObligation ? "Editar Obrigação" : "Nova Obrigação"}
        selectObligation={selectedObligation}
        onSubmit={handleFormSubmit}
      />
      {toast.show && (
        <Toast
          type={toast.type}
          message={toast.message}
          duration={3000}
          onClose={() => setToast({ ...toast, show: false })}
        />
      )}

    </div>
  );
};

export default Obligations;